/**
 * Product Configurations
 * ======================
 * Single source of truth for all product definitions.
 * Used by CRM API and Lead Intake Modal.
 */

/**
 * Product definitions with metadata
 * - id: Unique identifier used in API calls
 * - name: Display name
 * - subtitle: Short descriptor
 * - description: Full description for forms
 * - color: Brand color for UI styling
 * - fields: Form fields relevant to this product
 */
export const PRODUCTS = {
  'swiss-k12': {
    id: 'swiss-k12',
    name: 'SWISS Essentials',
    subtitle: 'K-12 Schools',
    description: 'Student Wellness and Institutional Safety Standards for K-12 schools',
    color: '#F7941D', // SWISS Orange
    fields: ['institution', 'teachers', 'students'],
  },
  'swiss-highered': {
    id: 'swiss-highered',
    name: 'SWISS HigherEd',
    subtitle: 'Colleges & Universities',
    description: 'Campus wellness certification for higher education institutions',
    color: '#7FB069', // Wellness Green
    fields: ['institution', 'faculty', 'students'],
  },
  'crew': {
    id: 'crew',
    name: 'CREW Essentials',
    subtitle: 'Corporate Wellness',
    description: 'Comprehensive workplace wellness certification for organizations',
    color: '#0D5A6A', // Teal
    fields: ['institution', 'managers', 'employees'],
  },
  'elevate': {
    id: 'elevate',
    name: 'ELEVATE',
    subtitle: 'Professional Training',
    description: 'CPD-accredited professional training programs for mental health practitioners',
    color: '#5A8B7A', // Sage Green
    fields: ['institution', 'trainees'],
  },
  'intellicare': {
    id: 'intellicare',
    name: 'IntellicareAI',
    subtitle: 'AI-Powered Wellness',
    description: 'Enterprise AI mental wellness solutions',
    color: '#7FB069', // Wellness Green
    fields: ['institution', 'users'],
  },
  'thrive': {
    id: 'thrive',
    name: 'Thrive Learning',
    subtitle: 'Wellness Education',
    description: 'Comprehensive wellness training and learning programs',
    color: '#D4A437', // Gold
    fields: ['institution', 'learners'],
  },
  'mosaic': {
    id: 'mosaic',
    name: 'MOSAIC Assessments',
    subtitle: 'Wellness Assessment Platform',
    description: 'Integrated mental wellness assessment platform across 5 life domains',
    color: '#5B4FCF', // Deep Indigo
    fields: ['institution', 'users'],
  },
  'counseling': {
    id: 'counseling',
    name: 'Counseling Services',
    subtitle: 'Professional Support',
    description: 'Professional counseling and therapy services',
    color: '#7FB069', // Wellness Green
    fields: ['personal'],
  },
};

/**
 * Products as an array (for iteration in UI components)
 */
export const PRODUCTS_LIST = Object.values(PRODUCTS);

export default {
  PRODUCTS,
  PRODUCTS_LIST,
};
